import { get, isEmpty } from "lodash";
import { InferGetServerSidePropsType } from "next";
import React from "react";
import Breadcrumb from "~/components/Breadcrumb";
import Container from "~/components/Container";
import SEOTags from "~/components/SEOTags";
import { Identifiers, SectionsKey } from "~/constants/enum";
import { QUERY_GET_CMS_BLOCKS } from "~/data/home";
import { GET_SCHEMA_ABOUT } from "~/data/schemas/schema.gql";
import Layout from "~/layouts/ThemeLayout";
import AboutSchema from "~/schema/AboutSchema";
import { initializeSSRApollo } from "~/utils/apollo-client";
import { getPageStruct, renderSectionNew } from "~/utils/pageTwo";
import { getTheme } from "~/utils/theme";

const pageStruct = getPageStruct(getTheme(), "about");

const About = ({
  data,
  loading,
  configSchema,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const cmsBlocks = get(data, "cmsBlocks.items[0].content", "") as string;

  const sections: any = pageStruct?.children
    ?.sort((a: any, b: any) => a.order - b.order)
    .map((item: any) => {
      const Section = renderSectionNew(item);
      return {
        id: item.id,
        order: item.order,
        dataKey: item.dataKey,
        identifier: item.identifier,
        component: Section ?? null,
      };
    });

  const { meta_description, meta_title, meta_keywords, url_key, title } =
    data?.cmsPage || {};
  const sectionData = {
    [SectionsKey.CMSPage]: {
      cmsData: cmsBlocks,
      loading,
    },
  };
  return (
    <Layout>
      <SEOTags
        title={meta_title}
        description={meta_description}
        keywords={meta_keywords}
        url={url_key}
      />
      <AboutSchema config={configSchema} />
      <Container
        rootClassName="py-10 lg:py-16 lg:pt-3"
        className="flex flex-col gap-8"
      >
        <Breadcrumb items={[{ title: "Home", path: "/" }, { title: title }]} />
        {sections?.map((item: any, index: number) => {
          const Section = item.component;
          return (
            <React.Fragment key={`section-${index}`}>
              {Section ? (
                <Section {...get(sectionData, item.dataKey, {})} />
              ) : null}
            </React.Fragment>
          );
        })}
      </Container>
    </Layout>
  );
};

export default About;

export async function getServerSideProps() {
  const apolloClient = initializeSSRApollo({
    httpLinkProps: { useGETForQueries: true },
  });

  let res = {} as any;
  try {
    const [data, schemaRes] = await Promise.all([
      apolloClient.query({
        query: QUERY_GET_CMS_BLOCKS,
        variables: {
          identifiers: [Identifiers.NewAbout],
        },
        context: { fetchOptions: { method: "GET" } },
      }),
      apolloClient.query({
        query: GET_SCHEMA_ABOUT,
      }),
    ]);
    res = {
      ...res,
      ...data,
      configSchema: schemaRes?.data?.MarketingConfig?.schemaAbout || {},
    };
  } catch (error) {
    console.error(error, "QUERY_SEO_CATEGORY");
  }

  if (isEmpty(res)) {
    return {
      notFound: true,
    };
  }
  return { props: { ...res } };
}
